import { cn } from "@/shared/utils/cn";
import { ACCENTS } from "@/shared/theme";
import { type Mode } from "@/shared/mode/types";
import { useTabHistory } from "@/shared/state/use-tab-history";

const MODE_LIST: { mode: Mode; label: string }[] = [
  { mode: "instaflix", label: "Instaflix" },
  { mode: "reelsflix", label: "Reelsflix" },
  { mode: "movieflix", label: "Movieflix" },
];

export function ModePills() {
  const { currentMode, tapMode } = useTabHistory();
  return (
    <div className="flex items-center gap-1 p-1 rounded-full glass">
      {MODE_LIST.map((m) => {
        const active = m.mode === currentMode;
        return (
          <button
            key={m.mode}
            onClick={() => tapMode(m.mode)}
            className={cn(
              "px-3 py-1.5 rounded-full text-[11px] font-semibold tracking-wider uppercase transition-all duration-300",
              active
                ? cn("text-velvet bg-rose-100", ACCENTS[m.mode].shadowClass)
                : "text-white/60 hover:text-white/90",
            )}
            style={active ? { boxShadow: `0 0 20px ${ACCENTS[m.mode].glow}` } : undefined}
          >
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
